import { ExpandedCourse } from "./coursesLoader";
import styles from "./Course.module.scss";
import Material from "./Material";
import { FormattedMessage } from "react-intl";
import { useLayoutData } from "../layout/myCoursesLayoutLoader";

export default function Course({
  title,
  displayNotes,
  courseMaterials,
}: ExpandedCourse) {
  const noMaterialsMessage = useLayoutData().config.assets.notFound || (
    <FormattedMessage defaultMessage="You currently have no materials associated with this course." />
  );
  return (
    <div className={styles.courseContainer}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.notes}>{displayNotes}</div>
      {courseMaterials.length === 0 ? (
        <div className={styles.noMaterialsContainer}>
          <div className={styles.noMaterials}>{noMaterialsMessage}</div>
        </div>
      ) : (
        <ul className={styles.materialList}>
          {courseMaterials.map((courseMaterial) => (
            <Material
              key={`${courseMaterial.id}:${courseMaterial.vbid}`}
              courseMaterial={courseMaterial}
            />
          ))}
        </ul>
      )}
    </div>
  );
}
